import React from 'react';
import PropTypes from 'prop-types';
import { useLabels } from 'wsm-common-data';

const FilterItem = ({ id, label, type, handleFilterRemove }) => {
	const labels = useLabels();

	const handleClick = (e) => {
		e.preventDefault();
		handleFilterRemove(type, id);
	};

	return (
		<button
			type="button"
			className="pill chip chip-default chip-condensed facet-filter"
			onClick={handleClick}
			aria-label={labels
				.get('FILTER_VALUE_CLICK_TO_REMOVE')
				.replace('{filter}', type)
				.replace('{value}', label)}
		>
			{label} <i className="ddc-icon ddc-icon-remove2" />
		</button>
	);
};

FilterItem.propTypes = {
	id: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
	type: PropTypes.string.isRequired,
	handleFilterRemove: PropTypes.func.isRequired
};

export default FilterItem;
